import 'whatwg-fetch';

/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */
function parseJSON(response) {
	return response.json();
}

function throwError(response) {
	const error = new Error(response.statusText);
	error.response = response;
	throw error;
}

function parseBlob(response) {
	return response.blob();
}

/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */

export default function request(url, options) {
	const isJSON = options.headers['Content-Type'] === 'application/json';
	return fetch(url, options).then((response) => {
		if (isJSON && response.status !== 401) {
			return parseJSON(response);
		} else if (!isJSON && response.status === 200) {
			return parseBlob(response);
		}
		throwError(response);
	});
}
